import { RouteRecordName } from "vue-router";
import CacheArrayCore from "./core-array.cache";

class TableCache extends CacheArrayCore {
  type: string;
  name: string;
  updateStorage: boolean = false;

  constructor(type: any = "defaultType", name: any = "defaultName") {
    super(`table_${type}_${name}`);

    this.type = type;
    this.name = name;
    this.updateStorage = false;
  }

  restoreState(
    name: RouteRecordName | null | undefined, 
    emitEvent: string, 
    updater: ((emitEvent: string, data: any) => void) | null
  ) {
    const data = JSON.parse(localStorage.getItem(`table_${emitEvent}_${name?.toString()}`) || "null");
    if (data && updater) {
      updater(emitEvent, data);
    }
  }

  async autoRestore(
    updater: ((emitEvent: string, data: any) => void) | null
  ): Promise<void> {
    const route = useRoute();

    return new Promise<void>((resolve) => {
      const interval = setInterval(() => {
        if (!this.updateStorage) {
          this.restoreState(route.name, "sort", updater);
          this.restoreState(route.name, "filters", updater);

          this.updateStorage = true;
          clearInterval(interval);
          resolve();
        }
      }, 300);
    });
  }
}

export default new TableCache();
export { TableCache };